import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Users } from "lucide-react";
import { api } from "../lib/api";
import CounsellorCard from "./CounsellorCard";

export default function CounsellorsSection() {
  const navigate = useNavigate();
  const [list, setList] = useState([]);

  useEffect(() => {
    api.get("/counsellors/public").then((r) => setList(r.data)).catch(() => {});
  }, []);

  if (list.length === 0) return null;

  return (
    <section id="counsellors" className="bg-white py-16 md:py-24">
      <div className="max-w-[1240px] mx-auto px-5">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-[#2b8cf0]/10 text-[#2b8cf0] text-xs font-semibold font-head">
            <Users size={14} /> OUR EXPERTS
          </span>
          <h2 className="font-head text-3xl md:text-4xl font-bold text-[#16244F] mt-4">Meet Our Counsellors</h2>
          <div className="mx-auto mt-4 h-1 w-20 rounded-full bg-[#F58220]" />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-7">
          {list.slice(0, 4).map((c) => (
            <CounsellorCard key={c.id} c={c} />
          ))}
        </div>

        {list.length > 4 && (
          <div className="text-center mt-10">
            <button onClick={() => navigate("/counsellors")} className="inline-flex items-center gap-2 border-2 border-[#16244F] text-[#16244F] hover:bg-[#16244F] hover:text-white font-head font-semibold px-6 py-3 rounded-lg transition-colors">
              View All Counsellors <ArrowRight size={17} />
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
